// Appels du portail client (/api/portal/*). `as` = id du compte client regardé
// par un admin (aperçu, ?as= dans l'adresse) ; absent pour le client lui-même.
import axios from '@/axios.js'

function params (as) {
  return as ? { as } : {}
}

export function portalGet (path, as) {
  return axios.get(`/portal${path}`, { params: params(as) }).then(res => res.data)
}

// { code, message } de l'API, y compris quand la réponse attendue était un blob (PDF).
export async function readError (err) {
  let data = err && err.response && err.response.data
  if (typeof Blob !== 'undefined' && data instanceof Blob) {
    try { data = JSON.parse(await data.text()) } catch (e) { data = null }
  }
  return { code: (data && data.code) || null, message: (data && data.message) || null }
}

export async function errorMessage (err, fallback) {
  return (await readError(err)).message || fallback
}

function filenameOf (res, fallback) {
  const cd = (res.headers && res.headers['content-disposition']) || ''
  const m = cd.match(/filename="?([^";]+)"?/)
  return m ? m[1] : fallback
}

/**
 * Ouvre le PDF d'un devis / d'une commande (kind 'order') ou d'une facture
 * (kind 'invoice') dans un nouvel onglet. L'onglet est ouvert AVANT l'appel
 * (au clic), sinon le navigateur le bloque comme fenêtre surgissante ; sans
 * onglet (bloqué quand même), le fichier est téléchargé.
 */
export async function openPdf (kind, id, as) {
  const win = window.open('', '_blank')
  try {
    const res = await axios.get(`/portal/${kind}/${id}/pdf`, { params: params(as), responseType: 'blob' })
    const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
    if (win) {
      win.location.href = url
    } else {
      const a = document.createElement('a')
      a.href = url
      a.download = filenameOf(res, `${kind}_${id}.pdf`)
      document.body.appendChild(a)
      a.click()
      a.remove()
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000)
  } catch (err) {
    if (win) win.close()
    throw err
  }
}
